<div *ngIf="!loadedSession || !loadedNextSession || !loadedRating">
  Loading...
</div>
<form class="tookplace-forms" [formGroup]="reportForm" *ngIf="loadedSession && loadedNextSession && loadedRating">
  <app-confirm-identity [formation]="formation"></app-confirm-identity>

  <!-- Validation des exercices offsite déplacée ici -->
  <div class="offsite-exercice-validation" *ngIf="pendingExerciceOffsite && pendingExerciceOffsite.length > 0">
    <div class="form-subsec-title">Exercice Offsite</div>
    <div class="title">Please report which exercises have been completed and which remain unfinished.</div>
    <div class="offsite-tasks-list">
      <div class="offsite-task-row report-takeplace"
        *ngFor="let task of taskForm.get('tasks')['controls']; let i = index" [formGroup]="task">
        <span class="task-title">{{ pendingExerciceOffsite[i]?.what.title }}</span>
        <div class="takeplace-btn-wrapper">
          <mat-button-toggle-group formControlName="value">
            <mat-button-toggle class="toggle-true" [value]="true">
              <span translate>teacher.reports.yes-btn</span>
            </mat-button-toggle>
            <mat-button-toggle class="toggle-false" [value]="false">
              <span translate>teacher.reports.no-btn</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
  </div>

  <div class="forms-wrapper">
    <div class="form-subsec-title" translate>teacher.reports.feedback-text</div>
    <mat-form-field>
      <textarea matInput [formControl]="feedbackCtrl" name="feedback"></textarea>
      <mat-hint class="minLength" *ngIf="(feedbackCtrl.hasError('minlength') && feedbackCtrl.dirty)"><strong>Your
          feedback should be at least 100 characters</strong> </mat-hint>
      <mat-hint align="end">{{feedbackCtrl.value?.length}}</mat-hint>

    </mat-form-field>

    <ng-container *ngIf="nextOccurrence?.session">
      <div class="form-subsec-title" translate>{{translatePath}}.for-next-time-text</div>
      <mat-form-field>
        <textarea matInput [formControl]="nextTimeMessageCtrl" name="nextTime"></textarea>
        <mat-hint class="minLength"
          *ngIf="(nextTimeMessageCtrl.hasError('minlength') && nextTimeMessageCtrl.dirty)"><strong>Your feedback should
            be at least 100 characters</strong> </mat-hint>
        <mat-hint align="end">{{nextTimeMessageCtrl.value?.length}}</mat-hint>
      </mat-form-field>
    </ng-container>
  </div>

  <div id="upcoming-assigned" *ngIf="formation && sheetPermission">
    @if (formation && formation.percent_exercice_rate > 0) {
    <!-- <div class="form-subsec-title"><span translate>Training exercices progress overview</span></div>
    <lib-exercices-info-teacher-gauge [formation]="formation"></lib-exercices-info-teacher-gauge> -->

    <div class="form-subsec-title"><span translate>Total assigned exercises at this stage of the training</span></div>
    <app-progress-gauge class="progress-gauge" [formation]="formation"
      [extraShouldBeAssigned]="extraShouldBeAssigned"></app-progress-gauge>
    }

    @if (isSheetLanguageAvailable) {
    <div class="form-subsec-title"><span translate>teacher.report.next_time_study_sheet</span></div>
    @if (formation && pending) {
    <app-exercice-assigned #onsiteAssigned [formationId]="formation.id" [typeExercice]="'onsite'"
      [session]="pending.session.id" [reloadToken]="assignedReloadToken"
      (taskDeleted)="reloadExerciceDuration()"
      [canDeleteTask]="true"></app-exercice-assigned>
    }
    <!-- <app-sheet-assigned *ngIf=" formation" [formation]="formation"></app-sheet-assigned> -->
    <div>
      <button type="button" class="assignsheet-btn" *ngIf="formation" (click)="openAssign('onsite','1')"><span>Assign a
          vocabulary exercices</span></button>
      <button type="button" class="assignsheet-btn" *ngIf="formation" (click)="openAssign('onsite','2')"><span>Assign a
          grammar exercices</span></button>
    </div>
    }

  </div>

  <div class="reportPanel" *ngIf="pendingExerciceOffsite && pendingExerciceOffsite.length > 0">
    <div class="form-subsec-title">Exercice Offsite</div>
  </div>

  <div id="upcoming-assigned" *ngIf="formation">
    <div class="form-subsec-title"><span translate>Exercices for next time</span></div>
    @if (formation && pending) {
    <app-exercice-assigned #offsiteAssigned [formationId]="formation.id" [typeExercice]="'offsite'"
      [session]="pending.session.id" [reloadToken]="assignedReloadToken"
      (taskDeleted)="reloadExerciceDuration()"
      [canDeleteTask]="true"></app-exercice-assigned>
    }
    <button type="button" class="assignsheet-btn" (click)="openAssign('offsite')"><span>Assign a exercice
        offsite</span></button>
  </div>

  <div class="reportPanel">
    <div class="form-subsec-title">Student's Level</div>
    <div class="title">Please report the student's level in each category below. You may also specify how close the
      student is to the next level.</div>
    <div class="axes-wrapper">
      <div class="axe">
        <div class="axe_title">Grammar</div>
        <div class="axe_data">
          <div class="axe_data_title">Student's Level:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="grammarLevelCtrl">
              <mat-radio-button *ngFor="let level of cecrl_LEVEL" class="radioLevel" [value]="level">
                <span>{{ level }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="axe_data">
          <div class="axe_data_title">Level Percentage:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="grammarPercentCtrl">
              <mat-radio-button *ngFor="let percent of percentList" class="radioLevel" [value]="percent">
                <span class="radio">{{ percent }} %</span>
              </mat-radio-button>
            </mat-radio-group>
            <!-- <mat-form-field class="report-width" appearance="fill" >
              <input [formControl]="grammarPercentCtrl" matInput min="0" max="100" type="number" onkeyup="if(value<0) value=0;if(value>100) value=100;">
            </mat-form-field> -->
          </div>
        </div>
      </div>

      <div class="axe">
        <div class="axe_title">Expression</div>
        <div class="axe_data">
          <div class="axe_data_title">Student's Level:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="expressionLevelCtrl">
              <mat-radio-button *ngFor="let level of cecrl_LEVEL" class="radioLevel" [value]="level">
                <span>{{ level }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="axe_data">
          <div class="axe_data_title">Level Percentage:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="expressionPercentCtrl">
              <mat-radio-button *ngFor="let percent of percentList" class="radioLevel" [value]="percent">
                <span class="radio">{{ percent }} %</span>
              </mat-radio-button>
            </mat-radio-group>
            <!-- <mat-form-field class="report-width" appearance="fill" >
              <input [formControl]="expressionPercentCtrl" matInput min="0" max="100" type="number" onkeyup="if(value<0) value=0;if(value>100) value=100;">
            </mat-form-field> -->
          </div>
        </div>
      </div>

      <div class="axe">
        <div class="axe_title">Comprehension</div>
        <div class="axe_data">
          <div class="axe_data_title">Student's Level:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="comprehensionLevelCtrl">
              <mat-radio-button *ngFor="let level of cecrl_LEVEL" class="radioLevel" [value]="level">
                <span>{{ level }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="axe_data">
          <div class="axe_data_title">Level Percentage:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="comprehensionPercentCtrl">
              <mat-radio-button *ngFor="let percent of percentList" class="radioLevel" [value]="percent">
                <span class="radio">{{ percent }} %</span>
              </mat-radio-button>
            </mat-radio-group>
            <!-- <mat-form-field class="report-width" appearance="fill" >
              <input [formControl]="comprehensionPercentCtrl" matInput min="0" max="100" type="number" onkeyup="if(value<0) value=0;if(value>100) value=100;">
            </mat-form-field> -->
          </div>
        </div>
      </div>

      <div class="axe">
        <div class="axe_title">Vocabulary</div>
        <div class="axe_data">
          <div class="axe_data_title">Student's Level:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="vocabularyLevelCtrl">
              <mat-radio-button *ngFor="let level of cecrl_LEVEL" class="radioLevel" [value]="level">
                <span>{{ level }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="axe_data">
          <div class="axe_data_title">Level Percentage:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="vocabularyPercentCtrl">
              <mat-radio-button *ngFor="let percent of percentList" class="radioLevel" [value]="percent">
                <span class="radio">{{ percent }} %</span>
              </mat-radio-button>
            </mat-radio-group>
            <!-- <mat-form-field class="report-width" appearance="fill" >
              <input [formControl]="vocabularyPercentCtrl" matInput min="0" max="100" type="number" onkeyup="if(value<0) value=0;if(value>100) value=100;">
            </mat-form-field> -->
          </div>
        </div>
      </div>

      <div class="axe">
        <div class="axe_title">Accent</div>
        <div class="axe_data">
          <div class="axe_data_title">Student's Level:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="accentLevelCtrl">
              <mat-radio-button *ngFor="let level of cecrl_LEVEL" class="radioLevel" [value]="level">
                <span>{{ level }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="axe_data">
          <div class="axe_data_title">Level Percentage:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="accentPercentCtrl">
              <mat-radio-button *ngFor="let percent of percentList" class="radioLevel" [value]="percent">
                <span class="radio">{{ percent }} %</span>
              </mat-radio-button>
            </mat-radio-group>
            <!-- <mat-form-field class="report-width" appearance="fill" >
              <input [formControl]="accentPercentCtrl" matInput min="0" max="100" type="number" onkeyup="if(value<0) value=0;if(value>100) value=100;">
            </mat-form-field> -->
          </div>
        </div>
      </div>

      <div class="axe">
        <div class="axe_title">Overall Spoken Level</div>
        <div class="axe_data">
          <div class="axe_data_title">Student's Level:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="oralLevelCtrl">
              <mat-radio-button *ngFor="let level of cecrl_LEVEL" class="radioLevel" [value]="level">
                <span>{{ level }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div class="axe">
        <div class="axe_title">Overall Written Level</div>
        <div class="axe_data">
          <div class="axe_data_title">Student's Level:</div>
          <div>
            <mat-radio-group [color]="'primary'" [formControl]="writtenLevelCtrl">
              <mat-radio-button *ngFor="let level of cecrl_LEVEL" class="radioLevel" [value]="level">
                <span>{{ level }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ng-container *ngIf="expectedIncident">
    <div class="form-subsec-title" translate>{{translatePath}}.for-next-time-text</div>
    <mat-form-field>
      <textarea matInput [formControl]="description" name="nextTime"></textarea>
      <mat-hint class="minLength" *ngIf="(description.hasError('minlength') && description.dirty)"><strong>Your
          description should be at least 100 characters</strong> </mat-hint>
      <mat-hint align="end">{{description.value?.length}}</mat-hint>
    </mat-form-field>

  </ng-container>

  <div class="report-buttons-row">
    <button class="action-btn" (click)="save()" [disabled]="!reportForm.valid || saveLoading || !checkExerciceRate()">
      <span class="loader-wheel" *ngIf="saveLoading"></span>
      <span translate>Save</span>
    </button>
    <div *ngIf="!checkExerciceRate()" class="error_msg">
      <span translate>You must complete the required exercise rate before proceeding.</span>
    </div>
  </div>
</form>

<!-- Modal d'assignation d'exercices -->
<app-modal *ngIf="showAssignModal" [componentToLoad]="componentToLoad" [componentName]="componentName"
  [modalParams]="modalParams" [allowClose]="true" (emitEvent)="handleModalEvent($event)"></app-modal>